import React from "react";
import { string } from "prop-types";

const RightArrow = ({ arrowColor = "#34b8b5", height = 6.828, width = 10.828 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={height} height={width}>
    <defs />
    <path
      fill="none"
      stroke={arrowColor}
      strokeLinecap="round"
      strokeWidth="2"
      d="M1.415 1.415l4 4-4 4"
      data-name="Path 29"
    />
  </svg>
);

RightArrow.propTypes = {
  arrowColor: string,
  height: string,
  width: string,
};

export default RightArrow;
